// extracted by mini-css-extract-plugin
export default {"wrapper":"MultipleChoiceInputField_wrapper__PHmCP","choice":"MultipleChoiceInputField_choice__Mp0kd"};